module.exports = __webpack_public_path__ + "media/images/detail-hover-1d1c7efa20179b0dcbf961bfccb39a3c.svg";